<div class="head-sec">
  <p class="mb-0" mat-dialog-title>Modifying the listed product(s) will result in updating the Associate Crop order(s).</p>
  <p class="mb-0" mat-dialog-title>If you select cancel, the product(s) you intended to modify will not be changed.</p>
</div>

<mat-dialog-content>

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

    <ng-container matColumnDef="orderHeaderID">
      <th mat-header-cell *matHeaderCellDef> Order # </th>
      <td mat-cell *matCellDef="let row; let i = index"
          [attr.rowspan]="isFirstRowOfGroup(i) ? getRowSpan(row.orderHeaderID) : null"
          [style.display]="isFirstRowOfGroup(i) ? '' : 'none'">
        {{ row.orderHeaderID }}
      </td>
    </ng-container>

    <ng-container matColumnDef="brand">
      <th mat-header-cell *matHeaderCellDef> Variety </th>
      <td mat-cell *matCellDef="let row">{{ row.variety }}</td>
    </ng-container>

    <ng-container matColumnDef="previousQty">
      <th mat-header-cell *matHeaderCellDef> Previous Qty </th>
      <td mat-cell *matCellDef="let row">{{ row.previousQty }}</td>
    </ng-container>

    <ng-container matColumnDef="orderQty">
      <th mat-header-cell *matHeaderCellDef> Updated Qty </th>
      <td mat-cell *matCellDef="let row">{{ row.updatedQty }}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let row">{{ row.status }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

  </table>
  <div *ngIf="dataSource == undefined || (dataSource && dataSource.length == 0)" class="noDataMsg">
    <p class="padding-b47">No changes were made. Please modify at least one value before submitting.</p>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button [disabled]="dataSource == undefined || (dataSource && dataSource.length == 0)" class="btns w160" color="primary" (click)="onBackToSubmit()">Ok to Continue</button>
  <button mat-raised-button class="btns w160" color="primary cancel-btn" mat-dialog-close (click)="onCancel()">Cancel</button>
</mat-dialog-actions>
